import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useBrandConfig } from '../stores/brandConfigContext';

declare global {
  interface Window {
    dataLayer: any[];
  }
}

export const usePageTracking = () => {
  const location = useLocation();
  const { config: brandConfig, loading: brandLoading } = useBrandConfig();

  useEffect(() => {
    // No hacer nada mientras carga la configuración de marca
    if (brandLoading) {
      return;
    }
    
    // Extraer brandKeyword de la URL primero
    const segments = location.pathname.split('/').filter(Boolean);
    const brandKeyword = segments[0] || 'acme';
    
    // Obtener el Google Tag ID desde la configuración de marca (viene del API como GoogleTag)
    const googleTagId = brandConfig?.googleTag;
    
    // Si no hay Google Tag ID configurado, no hacer tracking
    if (!googleTagId) {
      console.log('[GTM] No Google Tag configured for this brand, skipping tracking');
      return;
    }
    
    // Obtener el GA4 Measurement ID (opcional, para configuración avanzada)
    const measurementId = brandConfig?.ga4MeasurementId;
    
    // Push al dataLayer para GTM (con delay para que Helmet actualice document.title)
    window.dataLayer = window.dataLayer || [];
    setTimeout(() => {
      window.dataLayer.push({
        'event': 'page_view',
        'brandKeyword': brandKeyword,
        'pagePath': location.pathname,
        'pageTitle': document.title,
        'googleTagId': googleTagId,
        'ga4MeasurementId': measurementId || null
      });
      
      console.log('[GTM] Page view pushed:', {
        brandKeyword,
        pagePath: location.pathname,
        pageTitle: document.title,
        googleTagId,
        measurementId
      });
    }, 100);
  }, [location.pathname, brandConfig?.googleTag, brandConfig?.ga4MeasurementId, brandLoading]);
};
